// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0fa26fe9","680":"966ae07e","705":"1713a15b"}[chunkId] + ".chunk.js";
};